import Component from './Component';

const TOP_THRESHOLD_CLASS = 'view-topThreshold';
const BOTTOM_THRESHOLD_CLASS = 'view-bottomThreshold';

export default class InView extends Component {

	/**
	 * @param {HTMLElement} element
	 * @param {Object} data
	 */
	constructor(element, data) {
		super(element, data);

		this.targets = data.targets ? Array.from(this.el.querySelectorAll(data.targets)) : [this.el];
		this.threshold = data.threshold || 0;
		this.detectOnce = data.hasOwnProperty('detectOnce') ? data.detectOnce : true;

		if ('IntersectionObserver' in window) {
			this._observerInit();
		} else {
			this._onScrollInit();
		}
	}


	_observerInit() {
		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				const target = entry.target;
				const intersectionRatio = entry.intersectionRatio;
				this._updateState(
					target,
					intersectionRatio,
					entry.boundingClientRect.top < entry.rootBounds.height / 2
				);
			});
		}, {
			threshold: this.threshold === 0 ? [0] : [0, this.threshold],
		});

		this.targets.forEach((target) => observer.observe(target));
	}


	_onScrollInit() {
		const callback = () => {
			window.requestAnimationFrame(() => {
				this.targets.forEach((target) => {
					const targetRect = target.getBoundingClientRect();
					const targetArea = targetRect.width * targetRect.height;
					const intersectionArea = (
						Math.max(0, Math.min(targetRect.left + targetRect.width, window.innerWidth) - Math.max(targetRect.left, 0)) // width
						*
						Math.max(0, Math.min(targetRect.top + targetRect.height, window.innerHeight) - Math.max(targetRect.top, 0)) // height
					);
					const intersectionRatio = intersectionArea / targetArea;
					this._updateState(
						target,
						intersectionRatio,
						targetRect.top < window.innerHeight / 2
					);
				});
			});
		};

		this.addEventListener(window, "scroll", callback);
		callback();
	}


	_updateState(target, intersectionRatio, targetTopAboveViewCenter) {
		const hasTopClassThreshold = target.classList.contains(TOP_THRESHOLD_CLASS);
		const hasBottomClassThreshold = target.classList.contains(BOTTOM_THRESHOLD_CLASS);
		const topThreshold = hasTopClassThreshold ? 0 : this.threshold;

		const topThresholdReached = (this.detectOnce && hasTopClassThreshold) || (intersectionRatio > topThreshold || targetTopAboveViewCenter);
		target.classList.toggle(TOP_THRESHOLD_CLASS, topThresholdReached);
		if (topThresholdReached) {
			this.onTopThreshold();
		}

		const bottomThresholdReached = (this.detectOnce && hasBottomClassThreshold) || intersectionRatio <= this.threshold && targetTopAboveViewCenter;
		target.classList.toggle(BOTTOM_THRESHOLD_CLASS, bottomThresholdReached);
		if (bottomThresholdReached) {
			this.onBottomThreshold();
		}
	}

	onTopThreshold() {

	}

	onBottomThreshold() {

	}
}
